import WaybillsTableColumnDate from './index.vue'
export default WaybillsTableColumnDate